import type { Medication as ApiMedication } from "@tandemdiabetes/sugarmate-api-react-client"
import type { Medication } from "src/types"

export function transformMedication(medication: ApiMedication): Medication {
  const {
    id,
    deleted,
    ...otherProps
  } = medication

  return {
    ...otherProps,
    id: `${id}`,
    is_deleted: !!deleted,
  }
}
